import { render, staticRenderFns } from "./AddProjectDeliverable.vue?vue&type=template&id=9d8d466a&"
import script from "./AddProjectDeliverable.vue?vue&type=script&lang=js&"
export * from "./AddProjectDeliverable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d8d466a')) {
      api.createRecord('9d8d466a', component.options)
    } else {
      api.reload('9d8d466a', component.options)
    }
    module.hot.accept("./AddProjectDeliverable.vue?vue&type=template&id=9d8d466a&", function () {
      api.rerender('9d8d466a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/AddProjectDeliverable.vue"
export default component.exports